import { render } from "./TenantPage.vue?vue&type=template&id=22e14c52"
import script from "./TenantPage.vue?vue&type=script&lang=js"
export * from "./TenantPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__